const GuestForgotPINMapper = (response) => {
    if (response) {
        return {
            message: response.msg,
            success: true,
        };
    }
    return {};
};
export default GuestForgotPINMapper;
